
/**
 * Returns a constructed object
 * @param {Object} viewModel The sidebar state
 * @return Object The option that was created
 */
export function makeMenuOptions(viewModel) {
    "use strict";

    return {
        products: viewModel.attr("products"),
        permissions: viewModel.attr("permissions"),
        conditions: {
            isReseller: viewModel.attr("isReseller"),
            isNotDriver: viewModel.attr("isNotDriver"),
            hasProducts: viewModel.attr("hasProducts"),
            mobileWorker: viewModel.attr("mobileWorker"),
            hasHOSReports: viewModel.attr("hasHOSReports"),
            hasIFTAReports: viewModel.attr("hasIFTAReports"),
            hasMapFeatures: viewModel.attr("hasMapFeatures"),
            hasEldFeatures: viewModel.attr("hasEldFeatures"),
            hasIftaFeatures: viewModel.attr("hasIftaFeatures"),
            hasDvirFeatures: viewModel.attr("hasDvirFeatures"),
            isUserRoleAdmin: viewModel.attr("isUserRoleAdmin"),
            hasHosPermission: viewModel.attr("hasHosPermission"),
            hideLogShowEdits: viewModel.attr("hideLogShowEdits"),
            hideFuelReceipts: viewModel.attr("hideFuelReceipts"),
            hasDvirPermission: viewModel.attr("hasDvirPermission"),
            licenseManagement: viewModel.attr("licenseManagement"),
            hasIftaPermission: viewModel.attr("hasIftaPermission"),
            isUserRoleVTAdmin: viewModel.attr("isUserRoleVTAdmin"),
            hasWorkOrderReports: viewModel.attr("hasWorkOrderReports"),
            hasWorkOrderFeatures: viewModel.attr("hasWorkOrderFeatures"),
            allowSubAccountBranding: viewModel.attr("allowSubAccountBranding"),
            hasMobileWorkerPermission: viewModel.attr("hasMobileWorkerPermission"),
            hasComplianceSupportCenterFeatures: viewModel.attr("hasComplianceSupportCenterFeatures")
        }
    };
}
